export default __webpack_public_path__ + "static/media/testimonials@3x.473f7f42.png";